import script from "./ElectronicCommerce.vue?vue&type=script&setup=true&lang=js"
export * from "./ElectronicCommerce.vue?vue&type=script&setup=true&lang=js"

import "./ElectronicCommerce.vue?vue&type=style&index=0&id=7730cdc4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7730cdc4"]])

export default __exports__